import { Avatar, Box, Card, CardContent, Grid, Typography } from '@mui/material';
import { useState } from "react";
import UploadAvatarDialog from '../../../../Components/UploadAvatarDialog';
import { useMicrospecDynamicUIContext } from '../../../../GlobalProvider';
import { useMicrospecThemeLanguageContext } from '../../../../Themes';

const AccountDetails = () => {
    const { cloudProvider } = useMicrospecDynamicUIContext()
    const { localizationProvider } = useMicrospecThemeLanguageContext()
    const { user, userProfile } = cloudProvider
    const [dialogOpen, setDialogOpen] = useState(false)

    const onDialogClose = () => {
        setDialogOpen(false)
    }

    const handleAvatarUpdate = async (downloadURL) => {
        // Update user profile with new avatar URL
        try {
            if (userProfile && userProfile.methods && userProfile.methods.updateUserProfile) {
                await userProfile.methods.updateUserProfile({
                    additionalData: {
                        "photo_url": downloadURL
                    },
                });
            }
            // Reload to show updated avatar
            window.location.reload();
        } catch (error) {
            console.error('Failed to update user profile:', error);
        }
    }

    return (
        <Grid item lg={4} md={6} xs={12} sx={{ marginBottom: 2 }}>
            <Card>
                <CardContent>
                    <Box
                        sx={{
                            alignItems: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            height: '100%'
                        }}>
                        <Avatar
                            id="avatar"
                            sx={{
                                height: 100,
                                width: 100,
                            }}
                            src={userProfile.attributes.photoURL}
                            onClick={()=>setDialogOpen(true)}
                        />
                        <Typography gutterBottom variant="h3">
                            {userProfile.attributes.displayName}
                        </Typography>
                    </Box>
                </CardContent>
            </Card>
            <UploadAvatarDialog 
                open={dialogOpen} 
                onClose={onDialogClose}
                onImageUploaded={handleAvatarUpdate}
                currentImageUrl={userProfile.attributes.photoURL}
                storageRef={`users/${user.uid}/avatar.jpg`}
                title={localizationProvider.translateByType({
                    type: "Internal",
                    text: "changeProfilePicture"
                })}
                description={localizationProvider.translateByType({
                    type: "Internal",
                    text: "changeProfilePictureDescription"
                })}
                aspectRatio={1}
                cropShape="round"
                maxWidth={400}
                quality={0.85}
            />
        </Grid>
    )
}


export default AccountDetails;
